import { useEffect } from "react";
import { SelectableColoredItem, SelectableItem } from "../../../processingActivity/ProcessingActivity.types";
import { IDotLegalRecordheader } from "./DotLegalRecordHeader";
import { useGroupEntitiesQuery } from "../../../processingActivity/hooks/useGroupEntitiesQuery.ts";
import { useProcessingActivityQuery } from "../../hooks/useSelectableItemQueries.ts";

import { useDotLegalQuery, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useDotLegalRecordHeaderDataMapping(props: IDotLegalRecordheader) {
    const groupEntityQuery = useGroupEntitiesQuery();
    const areaQuery = useDotLegalQuery<Array<SelectableColoredItem>>("/BusinessAreas/businessareas");
    const processingActivityQuery = useProcessingActivityQuery(props.onlyUserSpecific);

    let groupEntities = groupEntityQuery.allGroupEntities?.map((d) => {
        return { id: d.id, name: d.name };
    });

    useEffect(() => {
        if (groupEntities && groupEntities.length === 1 && props.isProcessingActivityLimitExceeded === false) {
            props.setSelectedGroupEntity(groupEntities[0].id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [groupEntityQuery.allGroupEntities]);

    return {
        isLoadingGroupEntities: groupEntityQuery.isLoading,
        groupEntities,
        isAreasLoading: areaQuery.isLoading,
        isProcessingActivitiesLoading: processingActivityQuery.isLoading,
        processingActivities: processingActivityQuery.data,
        processingAreas: areaQuery.data,
    };
}
